module.exports = {"RI23":"Raffles Institution Primary Mathematics World Contest 2023","IN23":"HeyMath! Challenge of the Week"}


//////////////////
// WEBPACK FOOTER
// ./src/config/meta_US.json
// module id = 328
// module chunks = 0